import { Container, useMediaQuery, useTheme } from '@material-ui/core';
import Box from '@material-ui/core/Box';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';
import FacebookIcon from '@material-ui/icons/Facebook';
import InstagramIcon from '@material-ui/icons/Instagram';
import LinkedInIcon from '@material-ui/icons/LinkedIn';
import YouTubeIcon from '@material-ui/icons/YouTube';
import { Link as RouterLink } from 'react-router-dom'
import Googleplay from '../img/Googleplay.png'
import ITunesStore from '../img/iTunes_Store.png'
import PrivacyPDF from '../pdf/Disclaimer.pdf'
import LegalDocPDF from '../pdf/DNA term and Condition.pdf'
import i18n from '../i18n';
import { withNamespaces } from 'react-i18next';
import Link from '@material-ui/core/Link'


const useStyles = makeStyles(theme => ({
  white: {
    color: 'white',
  },
  cyan: {
    color: 'cyan'
  },
  gridSpacing: {
    spacing: 2
  },
  flexGrow: {
    flexGrow: 1,
  },
  imageIcon: {
    display: 'flex',
    height: 'inherit',
    width: 'inherit'
  },
  iconRoot: {
    textAlign: 'center'
  },
  link: {
    color: "white",
    textDecorationLine: "initial",
    '&:hover': {
      cursor: 'pointer',
      color: theme.palette.primary.main
    }
  },
  headerGrid: {
    height: 50,
    paddingTop: 50
  },
  centerMdDown: {
    [theme.breakpoints.down("sm")]: {
      textAlign: "center"
    },
  }

}));
// complete it like aquamon
function Footer({ t }) {
  const classes = useStyles();
  const theme = useTheme();

  let isSmUp = useMediaQuery(theme.breakpoints.up('sm'));

  return (
    <Box>
      <Box pt={10} bgcolor="#000000">
        <Container>
          <Grid container className={`${classes.white} ${classes.centerMdDown}`} justify="space-around">
            {/* spacing not working */}
            <Grid container item xs={12} md={3} spacing={2} direction="column" >
              <Grid item>
                <Typography color="primary" className={`${classes.headerGrid}`}>
                  {t("feature")}
                </Typography>
              </Grid>
              <Grid item>
                <RouterLink to="/standardize-product-report-card" style={{ textDecorationLine: "initial" }}>
                  <Typography className={classes.link}>
                    {t("standardize-report-card")}
                  </Typography>
                </RouterLink>
              </Grid>
              <Grid item>
                <RouterLink to="/instant-insurance-planning" style={{ textDecorationLine: "initial" }}>
                  <Typography className={classes.link}>
                    {t("instant-insurance-planning")}
                  </Typography>
                </RouterLink>
              </Grid>
              <Grid item>
                <RouterLink to="/ai-bio-personal-solution" style={{ textDecorationLine: "initial" }}>
                  <Typography className={classes.link}>
                    {t("ai-bio-personal-solution")}
                  </Typography>
                </RouterLink>
              </Grid>
            </Grid>
            <Box pt={{ xs: 10 }} bgcolor="#000000"></Box>
            {/* This a hidden column for the future developement. If you want to uncomment this, please change other Grid their md to be 2 */}
            {/* <Grid container item xs={12} md={2} spacing={2} direction="column">
              <Grid item>
                <Typography color="primary" className={classes.headerGrid} >OUR COMPANY</Typography>
              </Grid>
              <Grid item>
                <Typography onClick={() => (console.log('hello world'))} className={classes.link}>About us</Typography>
              </Grid>
              <Grid item>
                <Typography onClick={() => (console.log('hello world'))} className={classes.link}>Media</Typography>
              </Grid>
              <Grid item>
                <Typography onClick={() => (console.log('hello world'))} className={classes.link}>Careers</Typography>
              </Grid>
              <Grid item>
                <Typography onClick={() => (console.log('hello world'))} className={classes.link}>FAQ</Typography>
              </Grid>
            </Grid> */}
            <Grid container item xs={12} md={3} spacing={2} direction="column">
              <Grid item>
                <Typography color="primary" className={classes.headerGrid}>
                  {t("useful-link")}
                </Typography>
              </Grid>
              <Grid item>
                <Typography className={classes.link} >
                  <a className={classes.link} href={LegalDocPDF} target="_blank">
                    {t("legal-documents")}
                  </a>
                </Typography>
              </Grid>
              <Grid item>
                <Typography className={classes.link} >
                  <a className={classes.link} href={PrivacyPDF} target="_blank">
                    {t("privacy")}
                  </a>
                </Typography>
              </Grid>
            </Grid>
            <Grid container item xs={12} md={3} spacing={2} direction="column">
              <Grid item>
                <Typography color="primary" className={classes.headerGrid}>
                  {t("contact-us")}
                </Typography>
              </Grid>
              {/* <Grid item>
                <Typography onClick={() => (console.log('hello world'))} className={classes.link}>Send us a message</Typography>
              </Grid> */}
              <Grid item>
                <Typography >Phone: +852 9879 6414</Typography>
              </Grid>
              <Grid item>
                <Typography >Email: info@mln.hk</Typography>
              </Grid>
            </Grid>
            <Grid container item xs={12} md={3} spacing={2} direction="column" justify="flex-start" alignItems="center">
              <Box className={classes.headerGrid}>
                <Grid item container spacing={2} direction="row" justify="space-around" alignItems="center">
                  <Grid item>
                    <a href={"https://www.facebook.com/mylifenetworkhk"} target="_blank">
                      <FacebookIcon fontSize="large" color="secondary" />
                    </a>
                  </Grid>
                  <Grid item>
                    <a href="https://hk.linkedin.com/company/mylife-network?trk=public_profile_topcard-current-company" target="_blank">
                      <LinkedInIcon fontSize="large" color="secondary" />
                    </a>
                  </Grid>
                </Grid>
                <Box p={2} />
                <Grid item container spacing={0} xs={12} direction="column" justify="center" alignItems="center">
                  <Grid item xs={12}>
                    <img src={ITunesStore} />
                  </Grid>
                  <Grid item xs={12}>
                    <img src={Googleplay} />
                  </Grid>
                </Grid>
              </Box>
            </Grid>
          </Grid>
        </Container>
      </Box>
      <Box style={isSmUp ? { height: 200 } : { height: 400 }} bgcolor="black" />
    </Box>
  );
}

export default withNamespaces()(Footer);